import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// Import Swagger UI CSS for global availability
import "swagger-ui-react/swagger-ui.css";
import posthog from 'posthog-js'; 
import { PostHogProvider } from "@posthog/react";
import App from "./App";
// import reportWebVitals from './reportWebVitals';

// Env-only — no literal key fallback in the bundle (issue #694). Without the env var,
// posthog stays uninitialized and captures no-op; set REACT_APP_POSTHOG_KEY per environment.
const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: process.env.REACT_APP_POSTHOG_HOST ?? "https://us.i.posthog.com",
    advanced_disable_flags: true,
  });
} else {
  console.warn("REACT_APP_POSTHOG_KEY not set — analytics disabled.");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}> 
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
